var EsLogsColumnNames;
(function (EsLogsColumnNames) {
    EsLogsColumnNames[EsLogsColumnNames["oppId"] = 'Opp Id'] = "oppId";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskCreated"] = 'Last Executed Task Created'] = "lastTaskCreated";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskError"] = 'Error'] = "lastTaskError";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskType"] = 'Last Executed Task Type'] = "lastTaskType";
    EsLogsColumnNames[EsLogsColumnNames["lastTaskUpdated"] = 'Last Executed Task Updated'] = "lastTaskUpdated";
    EsLogsColumnNames[EsLogsColumnNames["unprocessedNumber"] = '№ of Unprocessed Tasks'] = "unprocessedNumber";
})(EsLogsColumnNames || (EsLogsColumnNames = {}));
var EsLogsController = (function () {
    function EsLogsController(settings, env, $compile, $filter, socket, $scope, $state, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, moment) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.$state = $state;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.moment = moment;
        this.itemsLoaded = true;
        this.processing = true;
        this.exportFired = false;
        this.withError = false;
        this.importingExcel = false;
        this.bookmarks = [];
        this.tableItems = [];
        this.docTable = [];
        this.goToDetails = function (info) {
            _this.$state.go('admin.eslogs-details-view', {
                id: info.oppId
            });
        };
        this.rowCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function () {
                _this.$scope.$apply(function () {
                    _this.goToDetails(aData);
                });
            });
            return nRow;
        };
        this.withErrorHandler = function () {
            _this.bookmarks = [];
            _this.table.dtInstance.DataTable.search($('#eslogs-table_filter input').val()).draw();
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        };
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { BP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
    }
    EsLogsController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('order', [])
            .withOption('rowCallback', this.rowCallback)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('pagingType', 'simple')
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        })
            .withOption('initComplete', function () {
            $('#eslogs-table_filter input').unbind();
            // on search change
            $('#eslogs-table_filter input').bind('keyup', function (e) {
                if (e.keyCode === 13) {
                    _this.bookmarks = [];
                    _this.table.dtInstance.DataTable.search($('#eslogs-table_filter input').val()).draw();
                }
            });
            // on page change
            $('#eslogs-table').on('page.dt', function (e) {
                $('.tag').tooltip();
                var page = _this.table.dtInstance.DataTable.page.info().page;
                if (_this.currentPage && _this.currentPage > page) {
                    _this.bookmarks.pop();
                    _this.bookmarks.pop();
                }
                _this.currentPage = page;
            });
            // on length of page change
            $('#eslogs-table').on('length.dt', function (e, settings, len) {
                _this.bookmarks = [];
            });
        });
    };
    EsLogsController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/es-logs',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
                _this.itemsLoaded = true;
            },
            data: function (body) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    body.alphabetSearch = dt.context[0].alphabetSearch;
                }
                body.withError = _this.withError;
                body.bookmark = _this.bookmarks[_this.bookmarks.length - 1];
            },
            dataSrc: function (data) {
                _this.itemsLoaded = true;
                _this.tableItems = data.data;
                _this.bookmarks.push(data.bookmark);
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Custom Report data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, EsLogsController.TEMPLATE_CONFIRM).then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.itemsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    EsLogsController.prototype.generateColumn = function (columnName, renderFn) {
        var columnId = EsLogsColumnNames[columnName];
        var orderable = false;
        return this.DTColumnBuilder
            .newColumn(columnId)
            .withOption('name', columnId)
            .withOption('orderable', orderable)
            .withTitle(columnName ? columnName : columnId)
            .renderWith(renderFn ? renderFn : function (data) { return data ? data : ''; });
    };
    EsLogsController.prototype.buildColumns = function () {
        var _this = this;
        return [
            this.generateColumn(EsLogsColumnNames.oppId),
            this.generateColumn(EsLogsColumnNames.lastTaskType),
            this.generateColumn(EsLogsColumnNames.lastTaskCreated, function (date) { return date ? _this.moment(date).format('MM/DD/YYYY HH:mm:ss') : ''; }),
            this.generateColumn(EsLogsColumnNames.lastTaskUpdated, function (date) { return date ? _this.moment(date).format('MM/DD/YYYY HH:mm:ss') : ''; }),
            this.generateColumn(EsLogsColumnNames.unprocessedNumber, function (value) { return ("\n                    <div>\n                        " + (value ? value : '') + "\n                    </div>  "); }),
            this.generateColumn(EsLogsColumnNames.lastTaskError, function (value) {
                if (value) {
                    return "\n                            <div>\n                                <md-icon style=\"padding-left:5px; color:rgba(234, 35, 35, 0.62);\" md-svg-icon=\"error\" title=\"" + value + "\" > </md-icon>\n                            </div>\n                        ";
                }
                else {
                    return "";
                }
            }),
        ];
    };
    /**
     * Function to handle all errors
     */
    EsLogsController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    EsLogsController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    EsLogsController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        '$state',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder',
        'moment'
    ];
    EsLogsController.DATE_FORMAT = 'd MMM yyyy';
    EsLogsController.TEMPLATE_CONFIRM = 'confirm-prompt.html';
    return EsLogsController;
}());
var EsLogsComponent = (function () {
    function EsLogsComponent() {
        this.templateUrl = 'eslogs.html';
        this.controllerAs = 'vm';
        this.controller = EsLogsController;
    }
    return EsLogsComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider.icon('error', "/public/icons/warning--filled--32.svg");
})
    .component('eslogsSection', new EsLogsComponent());

//# sourceMappingURL=eslogs.component.js.map
